// Shared display formatters. Currently just ABV — every page was rolling
// its own `${x.abv}%` interpolation, which prints whatever precision the
// number happens to carry (an ABV of exactly 40 prints as "40%", not
// "40.00%"). Production/QC/duty figures need at least 2dp on screen even
// when the underlying value is a round number, without ever *losing*
// precision a more exact reading actually has (e.g. a QC read of 40.567
// should still show all three decimals, not get rounded down to 2).
export function fmtAbv(v) {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  if (Number.isNaN(n)) return null;
  const s = n.toString();
  const decimals = s.includes('.') ? s.split('.')[1].length : 0;
  return n.toFixed(Math.max(2, decimals));
}
